export interface RequestForQuoteSupplierResponseDto {
	lineItems: string;
	lookupId: string;
}

export class RequestForQuoteSupplierResponseDto implements RequestForQuoteSupplierResponseDto {
	constructor(data?: Partial<RequestForQuoteSupplierResponseDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}